const experienceData = [
  {
    id: 1,
    jobtitle: "Frontend Developer",
    companyname: "Softfeat Technologies",
    worktype: "Full-time",
    duration: "Nov-2022-Current",
    location: "Umarkhed Maharastra, INDIA",
    responsibility: [
      `Worked with team on contract/project basis with flexible working hours.`,
        `Implemented various features and functionalities using react hooks, custom components, and react router`,
        `Used React, Redux and Sass for creating the project.`,
        `Worked on a few more contract projects and provided support for other running projects in the company`,

    ],
  },
  // {
  //   id: 2,
  //   jobtitle: "Social Media Strategist",
  //   companyname: "NexaReach Marketing Agency",
  //   worktype: "Full-time",
  //   duration: "Sep 2020 - Jan 2021",
  //   location: "Tbilisi, Georgia",
  //   responsibility: [
  //     `Devised and executed dynamic social media strategies across platforms, resulting in a 25% growth in follower base and a 30% boost in user engagement.`,
  //     `Created engaging and shareable content, leveraging both visual and written components to enhance brand storytelling.`,
  //     `Collaborated with clients to understand their unique voice and objectives, tailoring social media plans to align with their brand identity.`,
  //     `Monitored social media trends and emerging platforms, recommending and implementing new strategies to keep clients ahead of the curve.`,
  //   ],
  // }
];

const educationData = [
  {
    name: "Sant Gadage Baba Amravati, University",
    status: "Bachelor of Computer Aplication",
    year: "2019",
  },
  // {
  //   name: "Cityville High School",
  //   status: "High School Diploma",
  //   year: "2012",
  // }
];

const certificationData = [
  // {
  //   name: "HTML and CSS in depth",
  //   source: "Meta",
  //   date: "Issued Sept 2022 · No Expiration Date"
  // },
  // {
  //   name: "Interactivity with JavaScript",
  //   source: "University of Michigan",
  //   date: "Issued Sept 2022 · No Expiration Date"
  // },
  // {
  //   name: "React Basics",
  //   source: "Meta",
  //   date: "Issued Sept 2022 · No Expiration Date"
  // }
];

export { experienceData, educationData, certificationData };
